import { fetchServiceCalibSourceRows } from 'pages/Robot/RobotView/RobotLeftBlock/Service/serviceCalibApi'
import ServiceCalibMap from 'pages/Robot/RobotView/RobotLeftBlock/Service/ServiceCalibMap'
import type { ServiceCalibCatalogItem } from 'pages/Robot/RobotView/RobotLeftBlock/Service/serviceCalibTypes'
import { buildServiceCalibCatalog } from 'pages/Robot/RobotView/RobotLeftBlock/Service/serviceCalibUtils'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { selectMission } from 'store/selectors/mission'

/**
 * Read-only facility service-point pins on Mission map (UX-MAP-M1).
 * Shows all lots + maintenance points of the mission's facility (not only scenario SP).
 */
const MissionScenarioServicePointsOnMap = ({ map }: { map: mapboxgl.Map | undefined }) => {
  const mission = useSelector(selectMission)
  const facilityId = mission.missionInfo?.facility_id ?? null
  const [items, setItems] = useState<ServiceCalibCatalogItem[]>([])

  useEffect(() => {
    let cancelled = false
    if (!facilityId) {
      setItems([])
      return
    }

    const load = async () => {
      try {
        const rows = await fetchServiceCalibSourceRows(facilityId)
        if (cancelled) return
        const catalog = buildServiceCalibCatalog(rows.lots, rows.maintenancePoints, rows.stations)
        setItems(catalog.mapItems)
      } catch (error) {
        console.warn('[MissionScenarioServicePointsOnMap] load failed', error)
        if (!cancelled) {
          setItems([])
        }
      }
    }

    load()
    return () => {
      cancelled = true
    }
  }, [facilityId])

  if (!facilityId || items.length === 0) {
    return null
  }

  return <ServiceCalibMap map={map} items={items} selectedKey={null} onSelectKey={() => {}} />
}

export default MissionScenarioServicePointsOnMap
